/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ErrorReducer.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date			  : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 30, 2019
 * Description   : ASDS-1419
 ******************************************************************************/
import Reducer from './reducer';
import CheckoutActionConstants from '../action-constants';
import { createReducer } from '../utils/redux-util';
import { AsdsReducerObject } from '../../../../../types';

class ErrorReducer extends Reducer {

    /**
     * @description ASDS-1419, error occurred reducer function.
     * @param state 
     * @param action 
     */
    static errorOccurred(state, action): AsdsReducerObject {
        return {
            ...state,
            payload: {
                error: {
                    errorMessage: action.payload.response,
                }
            }
        }
    }
}

/**
 * This handler deals with mapping of actions to reducer methods.
 * @type {{}}
 */
const userHandlers = {
    [CheckoutActionConstants.ERROR_HANDLER]: ErrorReducer.errorOccurred,
}

const initialState = {
    isSuccess: true,
    isFetching: false,
    payload: {
        error: {
            errorMessage: "",
        }
    }
};

export const errorReducer = createReducer(initialState, userHandlers);